import { MAX_UPLOAD_MB, BYTES_PER_MB } from "@/lib/constants";

const MAX_EDGE = 1800;
const JPEG_QUALITY = 0.85;
const isHeic = (file) => /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || "");

const loadImage = (blob) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("decode")); };
    img.src = url;
  });

const toJpeg = async (blob) => {
  const img = await loadImage(blob);
  const scale = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(img.width * scale);
  canvas.height = Math.round(img.height * scale);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  return new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY));
};

// Normalises phone photos (HEIC, huge JPEGs) into a web-friendly JPEG the server accepts.
export const prepareImage = async (file) => {
  let blob = file;
  if (isHeic(file)) {
    const heic2any = (await import("heic2any")).default;
    blob = await heic2any({ blob: file, toType: "image/jpeg", quality: JPEG_QUALITY });
    if (Array.isArray(blob)) blob = blob[0];
  }
  const needsConvert = blob.size > MAX_UPLOAD_MB * BYTES_PER_MB || !/^image\/(jpeg|png|webp|gif)$/.test(blob.type);
  if (needsConvert || blob.size > 1.5 * BYTES_PER_MB) {
    try { blob = await toJpeg(blob); } catch { /* fall through with original */ }
  }
  const base = (file.name || "photo").replace(/\.[^.]+$/, "");
  const ext = blob.type === "image/jpeg" ? "jpg" : (blob.type.split("/")[1] || "jpg");
  return new File([blob], `${base}.${ext}`, { type: blob.type });
};
